import imgLeagueDiamond from './league-diamond.png'
import imgLeaguePlatinum from './league-platinum.png'
import imgLeagueGold from './league-gold.png'
import imgLeagueSilver from './league-silver.png'
import imgLeagueBronze from './league-bronze.png'
import imgLeagueNone from './league-none.png'

export const getLeauge = (rank: number): {
  leagueIndex: number
  rank: number
  league: 'Diamond' | 'Platinum' | 'Gold' | 'Silver' | 'Bronze' | 'None'
  title: string
  ordinal: string
  image: string
} => {
  if (rank <= 100) {
    return {
      leagueIndex: 0,
      league: 'Diamond',
      rank,
      title: 'Top 100: Diamond',
      ordinal: getOrdinal(rank),
      image: imgLeagueDiamond,
    }
  }
  if (rank <= 1000) {
    return {
      leagueIndex: 1,
      league: 'Platinum',
      rank,
      title: 'Top 1000: Platinum',
      ordinal: getOrdinal(rank),
      image: imgLeaguePlatinum,
    }
  }
  if (rank <= 5000) {
    return {
      leagueIndex: 2,
      league: 'Gold',
      rank,
      title: 'Top 5000: Gold',
      ordinal: getOrdinal(rank),
      image: imgLeagueGold,
    }
  }
  if (rank <= 10000) {
    return {
      leagueIndex: 3,
      league: 'Silver',
      rank,
      title: 'Top 10000: Silver',
      ordinal: getOrdinal(rank),
      image: imgLeagueSilver,
    }
  }
  if (rank <= 40000) {
    return {
      leagueIndex: 4,
      league: 'Bronze',
      rank,
      title: 'Bronze',
      ordinal: getOrdinal(rank),
      image: imgLeagueBronze,
    }
  }
  return {
    leagueIndex: 5,
    league: 'None',
    rank,
    title: 'Not in any league',
    ordinal: getOrdinal(rank),
    image: imgLeagueNone,
  }
}

// Helper function to convert number to ordinal (1st, 2nd, 3rd, etc.)
const getOrdinal = (n: number): string => {
  const j = n % 10
  const k = n % 100
  if (j === 1 && k !== 11) {
    return n + 'st'
  }
  if (j === 2 && k !== 12) {
    return n + 'nd'
  }
  if (j === 3 && k !== 13) {
    return n + 'rd'
  }
  return n + 'th'
}
